import { render, staticRenderFns } from "./AdminDienstleister.vue?vue&type=template&id=6455d0fe&"
import script from "./AdminDienstleister.vue?vue&type=script&lang=js&"
export * from "./AdminDienstleister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports